import axios from "axios";
import api from "./api";

const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api/v1";

// Uses plain axios (no auth header) since these are public endpoints
export const getPublicOrganisations = () =>
  axios.get(`${BASE_URL}/accounts/signup/organisations/`);

export const submitSignupRequest = (data) =>
  axios.post(`${BASE_URL}/accounts/signup/`, data);

const authService = {
  async login(email, password) {
    const response = await api.post("/auth/login/", { email, password });
    const { access, refresh } = response.data;
    localStorage.setItem(ACCESS_TOKEN_KEY, access);
    localStorage.setItem(REFRESH_TOKEN_KEY, refresh);
    return response.data;
  },

  logout() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },

  getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  isAuthenticated() {
    return Boolean(localStorage.getItem(ACCESS_TOKEN_KEY));
  },
};

export default authService;
